import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { GradientBackground } from '@uikit/old/GradientBackgroundLoader/GradientBackgroundLoader';
import { SVGIcon } from '@uikit/old/Icon/Icon';

import { billingAppDetailsSelector } from '@redux/selectors/billings-app.selectors';
import { billingConciergeDetailsSelector } from '@redux/selectors/billings-concierge.selectors';
import { fetchAppBillingDetails } from '@redux/thunks/billings-app.thunks';
import { fetchConciergeBillingDetails } from '@redux/thunks/billings-concierge.thunks';
import { checkIsAnyNotLoaded, checkIsAnyPending } from '@utils/loadingChecks';
import { isConciergeRealm } from '@utils/realmIdentifier';

import './UseExistingCard.scss';

const CreditCardNumberRendrer = ({ creditCardNumber }: { creditCardNumber: string }) => {
  if (!creditCardNumber) {
    return <>{'You have no credit card in service'}</>;
  }

  return <>{`Use existing Credit Card **** **** **** ${creditCardNumber}`}</>;
};

const UseExistingCard = ({ onUseNewCard }: { onUseNewCard?: () => void }): JSX.Element => {
  const dispatch = useDispatch();

  const { data: appBillingDetails, loadingStatus: appBillingDetailsLs } =
    useSelector(billingAppDetailsSelector);
  const { data: conciergeBillingDetails, loadingStatus: conciergeBillingDetailsLs } =
    useSelector(billingConciergeDetailsSelector);

  const billingDetails = isConciergeRealm() ? conciergeBillingDetails : appBillingDetails;
  const billingDetailsLs = isConciergeRealm() ? conciergeBillingDetailsLs : appBillingDetailsLs;

  useEffect(() => {
    if (checkIsAnyPending(billingDetailsLs)) {
      if (isConciergeRealm()) {
        dispatch(fetchConciergeBillingDetails(true));
      } else {
        dispatch(fetchAppBillingDetails());
      }
    }
  }, []);

  return (
    <div className="use-existing-card__details">
      <div className="use-existing-card__details-text">
        {checkIsAnyNotLoaded(billingDetailsLs) ? (
          <GradientBackground width={50} height={24} />
        ) : (
          <CreditCardNumberRendrer creditCardNumber={billingDetails.card?.creditCardNumber} />
        )}
      </div>
      {onUseNewCard ? (
        <div className="use-existing-card__btn" onClick={onUseNewCard} role="button" tabIndex={0}>
          <SVGIcon icon="pen" color="#8F9199" />
        </div>
      ) : null}
    </div>
  );
};

export default UseExistingCard;
